interface ProgramOverviewProps {
  overview?: string;
  secondPara?: string;
}

export default function ProgramOverview({
  overview,
  secondPara,
}: ProgramOverviewProps) {
  const defaultOverview =
    "This program offers comprehensive education in Engineering with a focus on practical skills and industry-relevant knowledge. Students will engage with cutting-edge research and gain hands-on experience through projects and internships.";

  return (
    <div className="flex flex-col gap-2 py-4 w-full">
      <p className="font-medium text-black text-[16px] tracking-[-0.32px] leading-normal">
        Program Overview
      </p>
      <div className="pl-2">
        <p className="font-normal text-[var(--color-black-7)] text-[14px] tracking-[-0.56px] leading-[1.35]">
          {overview || defaultOverview}
        </p>
      </div>
      <div className="pl-2">
        <p className="font-normal text-[var(--color-black-7)] text-[14px] tracking-[-0.56px] leading-[1.35]">
          {secondPara || defaultOverview}
        </p>
      </div>
    </div>
  );
}
